'use strict';

require('array.prototype.flat/auto');
require('array.prototype.flatmap/auto');

require('symbol.prototype.description/auto');

require('object.fromentries/auto');

require('./es2020');



//////////////////
// WEBPACK FOOTER
// ./node_modules/airbnb-js-shims/target/es2019.js
// module id = 1130
// module chunks = 31